import React, { useState } from "react";
import "./ChangeStatus.css";
import { changeTxnStatus } from "../../config/LiveApi";
import ConfirmationModal from "../../components/common/ConfirmModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const ChangeStatus = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [loading, setLoading] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [orders, setOrders] = useState([
    { id: "", utr: "", status: "Success", remark: "" },
  ]);

  const handleAddOrder = (index) => {
    const newOrders = [...orders];
    const { id, status } = newOrders[index];
    if (id.trim()) {
      newOrders.push({ id: "", utr: "", status: "Success", remark: "" });
      setOrders(newOrders);
    }
  };

  const handleRemoveOrder = (index) => {
    const newOrders = orders.filter((_, i) => i !== index);
    setOrders(newOrders);
  };

  const handleInputChange = (index, field, value) => {
    const newOrders = [...orders];
    newOrders[index][field] = value;
    setOrders(newOrders);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const userConfirmed = await openConfirmation();
    if (!userConfirmed) return;
    orders.filter(async (order) => {
      if (order.id) {
        try {
          await changeTxnStatus(token, order);
        } catch (err) {
          toast.error(`Status could not be changed for order id: ${order.id}`);
        }
      }
    });
    setOrders([{ id: "", utr: "", status: "Success", remark: "" }]);
    setLoading(false);
    toast.success("Status updated for transactions");
  };

  const openConfirmation = () => {
    return new Promise((resolve) => {
      setIsConfirmModal(() => ({
        isOpen: true,
        onResolve: resolve,
      }));
    });
  };

  return (
    <>
      <h1 className="change-status-head">Change Status</h1>
      <div className="change-status-container">
        <table className="order-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Change Status To</th>
              <th>UTR(Optional)</th>
              <th>Remark</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td>
                  <input
                    className="change-status-input"
                    type="text"
                    placeholder="Enter Order ID"
                    value={order.id}
                    onChange={(e) =>
                      handleInputChange(index, "id", e.target.value)
                    }
                  />
                </td>
                <td>
                  <select
                    className="change-status-select"
                    value={order.status}
                    onChange={(e) =>
                      handleInputChange(index, "status", e.target.value)
                    }
                  >
                    <option value="Success">Success</option>
                    <option value="Failed">Failed</option>
                  </select>
                </td>
                <td>
                  <input
                    className="change-status-input"
                    type="text"
                    placeholder="Enter UTR"
                    value={order.utr}
                    onChange={(e) =>
                      handleInputChange(index, "utr", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    className="change-status-input"
                    type="text"
                    placeholder="Enter Remark"
                    value={order.remark}
                    onChange={(e) =>
                      handleInputChange(index, "remark", e.target.value)
                    }
                  />
                </td>
                <td>
                  <button
                    className="action-btn"
                    onClick={() => handleAddOrder(index)}
                  >
                    ✔
                  </button>
                  <button
                    className="action-btn"
                    onClick={() => handleRemoveOrder(index)}
                  >
                    ✘
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="submit-btn" onClick={handleSubmit}>
          {loading ? <div className="button-loader"></div> : "Submit"}
        </button>
      </div>

      {isConfirmModal && (
        <ConfirmationModal
          onResolve={(decision) => {
            isConfirmModal.onResolve(decision);
            setIsConfirmModal(false);
          }}
        />
      )}
    </>
  );
};

export default ChangeStatus;
